export const aimTeaserContent = {
  title: 'Premium add-on',
  infoUrl: 'https://go.ipfabric.io/aim',
  supportEmail: 'support@ipfabric.io',
  infoText:
    'Application Infrastructure Mapping is a premium add-on. You can find more information',
  contactText:
    'If you want to get started with AIM as soon as possible, contact your Customer Success Manager, or get in touch at',
} as const;
